import {isDefined} from '@ls/js-utils';
import CalcType from 'state/Constants/CalcType';
import ScaleType from 'state/Constants/ScaleType';
import scope from './scope';

export default class TrackingErrorDefinition {
  #covarianceType;
  #factor;
  #scaleType;
  #calcType;

  constructor(props = {}) {
    const {covarianceType, factor, scaleType, calcType} = props;
    this.#covarianceType = covarianceType;
    this.#factor = factor;
    this.#scaleType = scaleType;
    this.#calcType = calcType;
  }

  get factor() {
    return this.#factor;
  }

  get covarianceType() {
    return this.#covarianceType;
  }

  get scaleType() {
    return this.#scaleType;
  }

  get calcType() {
    return this.#calcType;
  }

  get key() {
    return `${scope} - ${this.#factor}, ${this.#covarianceType}, ${this.#calcType}, ${this.#scaleType}`;
  }

  get complete() {
    return isDefined(this.#covarianceType) && isDefined(this.#factor) && isDefined(this.#scaleType) && isDefined(this.#calcType);
  }

  static getDefault = () => new TrackingErrorDefinition({
    factor: 'TOTAL',
    covarianceType: 'HIST',
    scaleType: ScaleType.Contribution,
    calcType: CalcType.Account,
  });

  copy = () => ({
    factor: this.#factor,
    covarianceType: this.#covarianceType,
    calcType: this.#calcType,
    scaleType: this.#scaleType,
  });
  setFactor = (value) => new TrackingErrorDefinition({
    ...this.copy(),
    factor: value,
  });
  setCovarianceType = (value) => new TrackingErrorDefinition({
    ...this.copy(),
    covarianceType: value,
  });
  setCalcType = (value) => new TrackingErrorDefinition({
    ...this.copy(),
    calcType: value,
  });
  setScaleType = (value) => new TrackingErrorDefinition({
    ...this.copy(),
    scaleType: value,
  });
}
